module.exports = __webpack_public_path__ + "assets/img/Type E (31).87858715.jpg";